import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoLeadingSpaceDirective]'
})
export class NoLeadingSpaceDirectiveDirective {

  constructor(private _el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: Event): void {
    const inputElement = this._el.nativeElement as HTMLInputElement;
    const initialValue = inputElement.value;

    // Remove any characters that are not numbers, letters, special characters, or spaces
    inputElement.value = initialValue.replace(/^\s+/g, '')  // Remove leading spaces
    .replace(/[^a-zA-Z0-9!@#$%^&*()_+={}\[\]:;"'<>,.?/\\|`~\- ]+/g, '');  // Remove invalid characters

    // Remove leading spaces
    inputElement.value = inputElement.value.replace(/^\s+/, '');

    // Stop propagation if the value changes
    if (initialValue !== inputElement.value) {
      event.stopPropagation();
    }
  }
}
